import React from 'react';
import { NavMenu } from '@shopify/app-bridge-react';
import { MAIN_NAVIGATION_ITEMS } from './constants';

const ShopifyNavigation: React.FC = () => {
  return (
    <NavMenu>
      <a href="/" rel="home">
        Home
      </a>
      {MAIN_NAVIGATION_ITEMS.map((item) => (
        <a key={item.href} href={item.href}>
          {item.title}
        </a>
      ))}
    </NavMenu>
  );
};

export default ShopifyNavigation;
